<template>
    <div class="search-panel__filter-slider">
        <div class="search-panel__slider-inputs">
            <div class="search-panel__slider-input-wrap">
                <span for="spPriceFrom" class="search-panel__slider-input-prefix">от</span>
                <input v-model="valueMin"
                       id="spPriceFrom"
                       ref="inputMin"
                       @focusout="focusOutMin"
                       @keypress="isNumber"
                       class="search-panel__slider-input"/>
                <span class="range-slider__value">{{ convertToDigit(valueMin) }}</span>
                <span class="search-panel__slider-input-suffix">{{ slider.label }}</span>
            </div>
            <div class="search-panel__slider-input-wrap">
                <span for="spPriceTo" class="search-panel__slider-input-prefix">до</span>
                <input v-model="valueMax"
                       id="spPriceTo"
                       ref="inputMax"
                       @focusout="focusOutMax"
                       @keypress="isNumber"
                       class="search-panel__slider-input" />
                <span class="range-slider__value">{{ convertToDigit(valueMax) }}</span>
                <span class="search-panel__slider-input-suffix">{{ slider.label }}</span>
            </div>
        </div>
        <VueSlider
                ref="slider"
                v-model="sliderValue.value"
                :silent="true"
                :dotSize="0"
                :height="1"
                :contained="true"
                :tooltip="'none'"
                :min="slider.min"
                :max="slider.max"
                :interval="slider.interval"
                @drag-start="dragStart"
                @drag-end="dragEnd"
        ></VueSlider>

        <input type="hidden" :name="slider.category + '[min]'" :value="slider.value[0]">
        <input type="hidden" :name="slider.category + '[max]'" :value="slider.value[1]">
    </div>
</template>

<script>
import InputMask from 'inputmask';
import Utils from '../../../common/scripts/utils';
import VueSlider from 'vue-slider-component';

export default {
    props: ['changed', 'slider'],

    components: {
        VueSlider
    },

    data() {
        return {
            valueMin    : 0,
            valueMax    : 0,
            oldVal      : null,
            focusedInput: false,
            sliderValue : this.slider
        };
    },

    watch: {
        slider() {
            this.sliderValue = this.slider;
        },

        sliderValue: {
            handler(val) {
                this.valueMin = this.toNumber(val.value[0]);
                this.valueMax = this.toNumber(val.value[1]);
            },
            deep: true
        },

        valueMin(val) {
            if (!this.toNumber(val)) {
                this.valueMin = 0;
            }
        },

        valueMax(val) {
            if (!this.toNumber(val)) {
                this.valueMax = 0;
            }
        }
    },

    mounted() {
        const optionsMask = {
            placeholder   : ' ',
            rightAlign    : false,
            radixPoint    : ',',
            autoGroup     : true,
            groupSeparator: ' ',
            groupSize     : 3,
            autoUnmask    : true
        };

        new InputMask('decimal', optionsMask).mask(this.$refs.inputMin);
        new InputMask('decimal', optionsMask).mask(this.$refs.inputMax);

        this.valueMin = this.slider.value[0];
        this.valueMax = this.slider.value[1];
    },

    methods: {
        // Запрет на ввод нечисловых значений (символы k/m выводят нули в маске, п)
        isNumber(event) {
            const evt = event ? event : window.event;
            const charCode = evt.which ? evt.which : evt.keyCode;

            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();

                return false;
            }

            return true;
        },

        convertToDigit(price) {
            return Utils.convertToDigit(price);
        },

        focusOutMin() {
            const inputValue = this.toNumber(this.valueMin);

            if (inputValue < this.slider.min) {
                this.slider.value[0] = this.slider.min;
                this.valueMin = this.slider.min;
            } else if (inputValue >= this.slider.value[1]) {
                this.slider.value[0] = this.slider.value[1];
                this.valueMin = this.slider.value[1];

                if (inputValue > this.slider.max) {
                    this.slider.value[1] = this.slider.max;
                    this.valueMax = this.slider.max;
                } else {
                    this.slider.value[1] = inputValue;
                    this.valueMax = inputValue;
                }
            } else {
                this.slider.value[0] = inputValue;
                this.valueMin = inputValue;
            }

            this.$refs.slider.setValue(this.slider.value);

            this.$nextTick(() => {
                this.dragEnd();
            });
        },

        focusOutMax() {
            const inputValue = this.toNumber(this.valueMax);

            if (inputValue > this.slider.max) {
                this.slider.value[0] = this.slider.min;
                this.valueMin = this.slider.min;
            } else if (inputValue < this.slider.value[0]) {
                this.slider.value[1] = this.slider.value[0];
                this.valueMax = this.slider.value[0];

                if (inputValue < this.slider.min) {
                    this.slider.value[0] = this.slider.min;
                    this.valueMin = this.slider.min;
                } else {
                    this.slider.value[0] = inputValue;
                    this.valueMin = inputValue;
                }
            } else {
                this.slider.value[1] = inputValue;
                this.valueMax = inputValue;
            }

            this.$refs.slider.setValue(this.slider.value);

            this.$nextTick(() => {
                this.dragEnd();
            });
        },

        dragStart() {
            this.oldVal = this.slider.value;
        },

        dragEnd() {
            if (this.oldVal === this.slider.value) {
                return;
            }

            this.updateChange();
            this.$emit('change');
            this.oldVal = this.slider.value;
        },

        updateChange() {
            if (!this.changed.min && (this.slider.value[0] !== this.toNumber(this.oldVal[0]))) {
                this.changed.min = true;
            }

            if (!this.changed.max && (this.slider.value[1] !== this.toNumber(this.oldVal[1]))) {
                this.changed.max = true;
            }
        },

        toNumber(string) {
            return Number(string.toString().replace(/\s/g, ''));
        }
    }
};
</script>
